import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { StockService } from '../../home/services/stocks.service';

export interface DialogData {
  getPOId: any;
}

@Component({
  selector: 'app-purchaseorder-delete-modal',
  templateUrl: './purchaseorder-delete-modal.component.html',
  styleUrls: ['./purchaseorder-delete-modal.component.scss']
})
export class PurchaseorderDeleteModalComponent implements OnInit {

  constructor(public stockService: StockService, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  cancel(){
    this.dialog.closeAll();
  }
  ngOnInit() {
  }

  deletePO(delete_po_id: any) 
  {
      //When submit the form - changing the button label text
      const x = document.getElementsByClassName("save_btn_txt");
      x[0].innerHTML = " Processing...";

      let po_input_id: any = {
        po_id: delete_po_id
      };

      this.stockService.deletePO(po_input_id).subscribe((response: any) => {
        //console.log( response );
        //return false;
      if(response.success == true) 
      {
        x[0].innerHTML = "Confirm";
        
        window.alert("purchase order deleted successfully");
        location.reload();
      }
      else 
      {
        window.alert("Something went wrong, Please try again later");
        location.reload();
      }
    })
  }

  close(){
    this.dialog.closeAll();
  }

}
